import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Grid,
} from "@mui/material";
import React from "react";
import Rating from "@mui/material/Rating";
import { useDispatch, useSelector } from "react-redux";
import { setAllowPost, setPostAnoumous } from "../../store/slice/feedback.slice";

const YourDetails = () => {
  const {addFields,isAllowPost,postAnoumous,basicLanguages}=useSelector((store)=>store?.feedback)
  const dispatch=useDispatch()

  const{css}=useSelector((store)=> store?.widgetSettings)
   const feedbackCss = css?.find((item) => item?.cssTabFieldsGroupName === "Feedback")?.fields;

  const averageRatingValue =
    addFields?.reduce((acc, field) => {
     
      return acc + field?.rating * 2;
    }, 0)
    const averageRating = addFields?.length == 1 ? averageRatingValue : Math.round(averageRatingValue / addFields?.length)
  return (
    <Box sx={{ padding: { xs: 2, sm: 3, md: 4 }}}>
      {" "}
 
        <Box >
          <Box>
            <Typography
              sx={{
                color: feedbackCss?.feedbackHeadingClr,
                fontSize: { xs: "20px", sm: "24px", md: "28px" },
                fontWeight: "medium",
              }}
            >
              {basicLanguages?.feedbackHeader}
            </Typography>
            <Typography
              sx={{
                color: feedbackCss?.feedbackInfoClr,
                fontSize: { xs: "12px", sm: "14px", md: "15px" },
                fontWeight: "regular",
                mt: 2,
              }}
            >
              {basicLanguages?.yourDetailLoremIpsum}
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={12} md={4}>
              {" "}
              {/* Full width on xs, half width on sm and md */}
              <Box
                sx={{
                  borderRadius: "10px",
                  border: `1px solid ${feedbackCss?.rationBoxBorderClr}`,
                  backgroundColor: feedbackCss?.ratingBoxBgClr,
                  p: 2,
                  height: "100%",
                  display:'flex',
                  justifyContent:'space-around',
                  alignItems:'center'
                }}
              >
                
                <Box>
                  <Rating
                    name="read-only"
                    value={averageRating / 2}
                    precision={0.5}
                    readOnly
                    sx={{ gap: { xs: 2, sm: 3, md: 5 } }}
                  />
                </Box>
                <Box sx={{ my: 1,p:2 }}>
                  <Typography
                    sx={{
                      color: feedbackCss?.ratingPercentaageClr,
                      fontSize: { xs: "18px", sm: "20px" },
                      fontWeight: "medium",
                    }}
                  >{`${averageRating}/10`}</Typography>
            
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
    
      <Box sx={{ mt: 2 }}>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox size="small" value={isAllowPost} name='isAllowPost' checked={isAllowPost} onChange={()=>dispatch(setAllowPost(!isAllowPost))} sx={{
              "&.Mui-checked": {
                color: feedbackCss?.checkBoxTickClr, // checked color
              }
            }}/>}
            label={
              <Typography
                sx={{
                  color: feedbackCss?.feedbackInfoClr,
                  fontSize: { xs: "12px", sm: "14px" },
                  lineHeight: "1.5rem",
                }}
              >
                {basicLanguages?.postFeedback}
              </Typography>
            }
          />
          <FormControlLabel
            control={<Checkbox size="small"  value={postAnoumous} name='postAnoumous' checked={postAnoumous} onChange={()=>dispatch(setPostAnoumous(!postAnoumous))}
            sx={{
              color: 'grey', // unchecked color
              "&.Mui-checked": {
                color: feedbackCss?.checkBoxTickClr, // checked color
              },
            }}
            />}
            label={
              <Typography
                sx={{
                  color: feedbackCss?.feedbackInfoClr,
                  fontSize: { xs: "12px", sm: "14px" },
                  lineHeight: "1.5rem",
                }}
              >
                {basicLanguages?.PostAnonymously}
              </Typography>
            }
          />
        </FormGroup>
      </Box>
    </Box>
  );
};

export default YourDetails;
